import { styled } from '@mybonus/ui';

export const Wrapper = styled.div`
	padding: 40px;
`;
